import { Component, Input, OnInit, signal, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Modal } from 'bootstrap';

@Component({
    selector: 'app-labDetails',
    templateUrl: './labDetails.component.html',
    styleUrl: './labDetails.component.scss',
    standalone: false
})
export class LabDetailsComponent implements OnInit {
    @Input() labDetailsData = signal<null | any>(null);
    currentComment: any;
    flattenedLabData: any[] = [];
    displayedColumns: string[] = ['observationDate', 'orderingProviderId', 'orderingProvider', 'valueType', 'loinc', 'loincDescription', 'observationValue', 'units', 'referencesRange', 'abnormalFlags', 'observationComment'];
    dataSource = new MatTableDataSource<any>([]);
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    actualData: any;
    flattenedArr: any;
    expandedRow: any = null;
    ngOnInit() {
        const details = this.labDetailsData().memberLabDetails;
        const flattenedArr = details.flatMap(d => d.labData);
        this.proccessData(flattenedArr);
        this.dataSource.data = this.actualData;
    }
    toggle(row) {
        this.expandedRow = this.expandedRow === row ? null : row;
    }

    isExpanded(row: any) {
        return this.expandedRow === row;
    }
    proccessData(data: any) {
        this.actualData = data.map((
           { observationDate,
            orderingProviderId,
            orderingProviderLastName,
            orderingProviderFirstName,
            valueType,
            loinc,
            loincDescription,
            observationValue,
            units,
            referencesRange,
            abnormalFlags,
            observationComment}
        ) => {
            return {
                observationDate:this.formatDate(observationDate),
                orderingProviderId,
                orderingProviderLastName,
                orderingProviderFirstName,
                valueType,
                loinc,
                loincDescription,
                observationValue,
                units,
                referencesRange,
                abnormalFlags,
                observationComment
            }

        })

    }
    formatDate(data:any){
       let spliteDate= data.split(" ");
       const [year,month,date]=spliteDate[0].split("-");
       return `${month}/${date}/${year}`;
    }
    applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
    viewComment(comment: string) {
        this.currentComment = comment;
        this.openModal("commentViewModal");
    }
    openModal(modalId: string) {
        const modal = new Modal(document.getElementById(modalId));
        modal.show();
    }

    closeModal(modalId: string) {
        const modalElement = document.getElementById(modalId);
        const modal = Modal.getInstance(modalElement);
        if (modal != null) {
            modal.hide();
        }
    }
    ngAfterViewInit() { 
        this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort;
     }

}